import { useBookEditor } from "../BookEditorProvider";

/**
 * Preview mode — Turn 5+ will render read-only pages from the same document.
 * Turn 1 provides a real mode tab that preserves bookId and page context.
 */
export default function PreviewMode() {
  const { book, pages, chapters, setMode } = useBookEditor();

  return (
    <div className="book-editor-preview-mode" data-testid="book-editor-preview-mode">
      <div className="book-editor-placeholder-card">
        <h2>Preview</h2>
        <p>
          Read-only print and digital preview for{" "}
          <strong>{book?.title || "this book"}</strong>. Preview will render from
          the same persisted pages as Canvas — not a separate layout copy.
        </p>
        <dl className="book-editor-meta-grid">
          <div>
            <dt>Persisted pages</dt>
            <dd>{pages?.length || 0}</dd>
          </div>
          <div>
            <dt>Chapters</dt>
            <dd>{chapters?.length || 0}</dd>
          </div>
        </dl>
        <p className="book-editor-hint">
          Page count comes from saved <code>book_pages</code>, not chapter-count math.
        </p>
        <button
          type="button"
          className="book-editor-btn"
          data-testid="preview-open-canvas"
          onClick={() => setMode("canvas")}
        >
          Open Canvas to edit pages
        </button>
      </div>
    </div>
  );
}
